import { InvokeCallback, Sender } from "xstate";
import { buildAuthorizationsApiWithToken } from "@rentablo/api/apiv1";
import i18next from "i18next";
import { Settings2FAContext } from "../types/Settings2FAContext";
import { Settings2FAEvent } from "../types/Settings2FAEvent";

const queryApi = async (
  callback: Sender<Settings2FAEvent>,
  code: number,
  userId?: number
) => {
  try {
    if (!userId) throw new Error("User ID is required");

    const authorizationsApi = await buildAuthorizationsApiWithToken();
    await authorizationsApi.verify2FA({
      userId,
      mfaSecret: code,
    });

    callback({ type: "ENABLE_SUCCESS" });
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
    callback({
      type: "ERROR",
      message: i18next.t(
        `settings.twoFA.messages.${!userId ? "error" : "invalidCodeError"}`
      ),
    });
  }
};

export const enable2FA =
  (
    context: Settings2FAContext,
    event: Settings2FAEvent
  ): InvokeCallback<Settings2FAEvent, Settings2FAEvent> =>
  (callback) => {
    if (event.type !== "SUBMIT_CODE") {
      throw new Error("Invalid event type");
    }
    if (!event.code) {
      throw new Error("TOTP secret is required");
    }

    queryApi(callback, event.code, context.userId);
  };
